import { Link } from 'react-router-dom';
import { useMe, usePuede } from '../lib/auth';
import { useMigas } from '../lib/migas';
import { Boton } from '../componentes/Boton';
import { Contenedor } from '../componentes/Contenedor';
import { Escudo } from '../componentes/iconos';

/**
 * Inicio de la aplicación.
 *
 * Todavía es un tablero mínimo: solo la cola de solicitudes, que es lo único
 * construido. Sirve además para comprobar que el rol y los permisos llegaron y
 * que `usePuede` oculta lo que tiene que ocultar.
 */
export function Inicio() {
  const { usuario } = useMe();
  // El inicio no lleva migas: es la raiz. Se declaran vacias para limpiar las
  // que dejo la pantalla anterior.
  useMigas([]);

  const puedeVerSolicitudes = usePuede('solicitudes.ver');
  const puedeCrearEmpresas = usePuede('empresas.crear');
  const puedeVerRespuestas = usePuede('respuestas.ver_individuales');

  if (!usuario) return null;

  return (
    <Contenedor ancho="panel">
      <h1 className="mb-1 text-2xl font-bold text-marino-800">Hola, {usuario.nombre}</h1>
      <p className="mb-8 text-marino-400">
        Sesión iniciada en <strong className="text-marino-700">{usuario.empresaNombre}</strong>.
      </p>

      {puedeVerSolicitudes && (
        <Link
          to="/solicitudes"
          className="mb-6 flex items-start gap-4 rounded-2xl border border-marino-100 bg-white p-6
            transition hover:border-naranja-300"
        >
          <span className="mt-0.5 shrink-0 text-naranja-500">
            <Escudo size={22} />
          </span>
          <div>
            <h2 className="font-semibold text-marino-800">Solicitudes de acceso</h2>
            <p className="mt-1 text-sm text-marino-500">
              Gente que se registró y espera aprobación. Conviene revisarla todos los días: si
              se atrasa, alguien no puede responder el cuestionario de su sesión.
            </p>
          </div>
        </Link>
      )}

      <section className="rounded-2xl border border-marino-100 bg-white p-6">
        <h2 className="mb-2 text-sm font-bold tracking-wider text-marino-400 uppercase">
          Lo que puedes hacer
        </h2>
        <p className="mb-5 text-sm text-marino-400">
          Esto aparece según tu rol. Que la interfaz lo oculte no es control de acceso: el
          servidor vuelve a validar cada permiso en cada petición.
        </p>
        <div className="flex flex-wrap gap-3">
          {puedeCrearEmpresas && <Boton variante="secundario">Registrar cliente</Boton>}
          {puedeVerRespuestas && <Boton variante="secundario">Ver respuestas</Boton>}
          {!puedeCrearEmpresas && !puedeVerRespuestas && (
            <p className="text-sm text-marino-400">Tu rol no tiene ninguna de estas acciones.</p>
          )}
        </div>
      </section>

      <p className="mt-8 text-center text-xs text-marino-400">
        Los módulos de cuestionarios todavía no están construidos.
      </p>
    </Contenedor>
  );
}
